/* Context module: exports provider, hook, and static value. */
/* eslint-disable react-refresh/only-export-components */
import { createContext, type ReactNode, useContext } from "react";
import type { AuthContextValue } from "./auth-core.types";

export const disabledAuthValue: AuthContextValue = {
  isEnabled: false,
  isAuthenticated: true,
  isLoading: false,
  user: undefined,
  error: undefined,
  logout: () => {},
  loginWithRedirect: async () => {},
  getAccessTokenSilently: async () => "",
  getIdTokenClaims: async () => undefined,
};

const AppAuthContext = createContext<AuthContextValue>(disabledAuthValue);

export function AppAuthContextProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: AuthContextValue;
}) {
  return <AppAuthContext.Provider value={value}>{children}</AppAuthContext.Provider>;
}

export function useAppAuthContext() {
  return useContext(AppAuthContext);
}
